import { User } from 'lucide-react';

const ChildSelector = ({ children, selectedChild, onSelectChild }) => {
  if (children.length === 0) return null;
  
  if (children.length === 1) {
    return (
      <div className="bg-white rounded-lg p-4 shadow-sm border border-gray-200">
        <div className="flex items-center gap-3">
          {selectedChild?.photo_url ? (
            <img 
              src={selectedChild.photo_url} 
              alt={selectedChild.name} 
              className="w-12 h-12 rounded-full object-cover"
            />
          ) : (
            <div className="w-12 h-12 rounded-full bg-blue-100 flex items-center justify-center">
              <User className="w-6 h-6 text-blue-600" />
            </div>
          )}
          <div>
            <h3 className="font-semibold text-lg" style={{ color: '#2C5F7F' }}>
              {selectedChild?.name}
            </h3>
            <p className="text-sm text-gray-600">
              {selectedChild?.class_name} • Room {selectedChild?.room_number}
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg p-4 shadow-sm border border-gray-200">
      <label className="block text-sm font-medium text-gray-700 mb-2">
        Select Child
      </label>
      <select
        value={selectedChild?.id || ''}
        onChange={(e) => {
          const child = children.find(c => c.id === e.target.value);
          onSelectChild(child);
        }}
        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
      >
        {children.map(child => (
          <option key={child.id} value={child.id}>
            {child.name} - {child.class_name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default ChildSelector;
